import PropTypes from "prop-types";
import {
  DropdownFilterWithSearch,
  DropdownMultiFilterWithCheckboxAndInitialValue,
  DropdownFilterWithDateRangePicker,
} from "../../components/DropdownFilter";

import { Table } from "antd";
import AssetDropdown from "./AssetDropdown";
import AssetDropdownSingle from "./AssetDropdownSingle";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFilters,
  savePreviousFilters,
  updatePageNo,
  updateUI,
  floorViewRequest,
} from "../../store/actions/asset";
import { isAssetActiveInZone } from "./common/utils/utils";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

function AssetList({floorview=false}) {
  const dispatch = useDispatch();
  const {
    isLoading,
    assetsList,
    count,
    pageSize,
    currentPage,
    filters,
    deviceNames,
    isFloorView,
    uniqueLocations,
    user,
  } = useSelector((state) => ({
    isLoading: state.asset.isLoading.assetList,
    assetsList: state.asset.data.assetList,
    count: state.asset.data.count,
    pageSize: state.asset.data.pageSize,
    currentPage: state.asset.data.currentPage,
    filters: state.asset.filters,
    deviceNames: state.asset.data.deviceNames,
    isFloorView: state.asset.ui.isFloorView,
    uniqueLocations: state.asset.data.uniqueLocations || [],
    user: state.auth.user,
  }));

  // const previousFilters = useSelector(state => state.asset.previousFilters);
  // useEffect(() => {
  //   if (previousFilters && location.pathname === "/assets") {
  //     dispatch(
  //       updateFilters({
  //         filters: {
  //           assetid: {
  //             sort: "desc",
  //             option: previousFilters.assetid?.option || [],
  //           },
  //         },
  //         sort: {
  //           field: "createdon",
  //           order: "desc",
  //         },
  //         //isRefresh: isRefresh,
  //         pageSize: previousFilters.pageSize,
  //         currentPage: previousFilters.currentPage
  //       })
  //     );
  //   }
  // }, [location.pathname, previousFilters, dispatch]);
  const dataSource = assetsList.map((asset, index) => {
    // const locationname = [];
    // if(asset?.currentlocation?.name){
    //   locationname.push(capitalizeFirstLetter(asset?.currentlocation?.name));
    // }
    // if(asset?.currentlocation?.floor?.name){
    //   locationname.push(capitalizeFirstLetter(asset?.currentlocation?.floor?.name));
    // }
    // if(asset?.currentlocation?.floor?.zone?.zone_name){
    //   locationname.push(capitalizeFirstLetter(asset?.currentlocation?.floor?.zone?.zone_name));
    // }
    // const location = locationname.length ? locationname.join("-") : asset?.location?.address || "Not assigned";
    return {
      key: index.toString(),
      status: (
        <div className="d-flex justify-content-center align-items-center">
          {/* <div>
      <Checkbox
        id={`checkbox-${index}`}
        name={`checkbox-${index}`}
        className="me-3"
      />
    </div> */}
          <div className={`status-${floorview && isAssetActiveInZone(asset)?'critical':asset?.assetstatus?.toLowerCase()}`}></div>
        </div>
      ),
      assetname: (
        <Link
          className="shipment-text-link"
          to={`/assets/${asset?.assetid}`}
          onClick={() => {
            dispatch(updateUI({ selectedLocation: null }));
            dispatch(
              savePreviousFilters({
                ...filters,
                pageSize,
                currentPage,
              })
            );
            dispatch(
              updateFilters({
                filters: {
                  assetid: {
                    sort: "asc",
                    option: asset.assetid,
                  },
                },
                sort: {
                  field: "createdon",
                  order: "desc",
                },
              })
            );
          }}
        >
          {asset?.assetname}
        </Link>
      ),
      device: Array.isArray(deviceNames)
        ? deviceNames.find((d) => d.uid === asset?.deviceid)?.name
        : asset?.devicename,
      location: floorview && isAssetActiveInZone(asset)?'Unknown' : asset?.locationzone || "Unknown",
      lastupdated: asset?.updatedat ? dayjs(asset?.updatedat).fromNow() : null,
      action: (
        <AssetDropdownSingle id={asset?.assetid} name={asset?.assetname} />
      ),
    };
  });

  const handleStatusFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          assetstatus: {
            sort: "",
            option: Object.entries(val.filters).map(([text, value]) => ({
              text: text,
              value: value,
            })),
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const handleStatusResetFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          assetstatus: {
            sort: "",
            option: Object.entries(val.filters).map(([text, value]) => ({
              text: text,
              value: false,
            })),
          },
          assetid: {
            sort: "",
            option: [],
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const handleAssetNameFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          assetname: {
            sort: val.isAsc ? "asc" : "desc",
            option: val.filters.text,
          },
        },
        sort: {
          field: "assetname",
          order: val.isAsc ? "asc" : "desc",
        },
      })
    );
  };

  const handleAssetNameResetFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          assetname: {
            sort: "asc",
            option: "",
          },
          assetid: {
            sort: "",
            option: [],
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const handleDeviceNameFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          devicename: {
            sort: val.isAsc ? "asc" : "desc",
            option: val.filters.text,
          },
        },
        sort: {
          field: "devicename",
          order: val.isAsc ? "asc" : "desc",
        },
      })
    );
  };

  const handleDeviceNameResetFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          devicename: {
            sort: "asc",
            option: "",
          },
          assetid: {
            sort: "",
            option: [],
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const handleLastUpdatedFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          updatedat: {
            sort: val.isAsc ? "asc" : "desc",
            option: {
              lastupdatedfrom: val.filters.text[0],
              lastupdatedto: val.filters.text[1],
            },
          },
        },
        sort: {
          field: "updatedat",
          order: val.isAsc ? "asc" : "desc",
        },
      })
    );
  };

  const handleLastUpdatedResetFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          updatedat: {
            sort: "asc",
            option: {
              lastupdatedfrom: "",
              lastupdatedto: "",
            },
          },
          assetid: {
            sort: "",
            option: [],
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const handleLocationFilter = (val) => {
    dispatch(
      updateFilters({
        filters: {
          locationzone: {
            sort: val.isAsc ? "asc" : "desc",
            option: val.filters.text,
          },
        },
        sort: {
          field: "locationzone",
          order: val.isAsc ? "asc" : "desc",
        },
      })
    );
  };

  const handleLocationResetFilter = (val) => {
    if (
      isFloorView &&
      Array.isArray(uniqueLocations) &&
      uniqueLocations?.length > 0
    ) {
      dispatch(
        floorViewRequest({
          location:
            Array.isArray(uniqueLocations) && uniqueLocations?.length > 0
              ? uniqueLocations[0]
              : null,
          floorIndex: 0,
        })
      );
    }
    dispatch(
      updateFilters({
        filters: {
          locationzone: {
            sort: "asc",
            option:
              isFloorView &&
              Array.isArray(uniqueLocations) &&
              uniqueLocations?.length > 0
                ? `${uniqueLocations?.[0]?.name} - ${uniqueLocations?.[0]?.floors?.[0]?.name}`
                : "",
          },
          assetid: {
            sort: "",
            option: [],
          },
        },
        sort: {
          field: "createdon",
          order: "desc",
        },
      })
    );
  };

  const columns = [
    {
      title: (
        <DropdownMultiFilterWithCheckboxAndInitialValue
        accountId={user?.accountId}
          text="Status"
          isSortable={false}
          onApply={handleStatusFilter}
          onReset={handleStatusResetFilter}
          menuItems={filters.assetstatus.option}
        />
      ),
      dataIndex: "status",
      key: "status",
    },
    {
      title: (
        <DropdownFilterWithSearch
        accountId={user?.accountId}
          text="Asset name"
          value={filters?.assetname?.option || ""}
          isSortable={true}
          onApply={handleAssetNameFilter}
          onReset={handleAssetNameResetFilter}
        />
      ),
      dataIndex: "assetname",
      key: "assetname",
    },
    {
      title: (
        <DropdownFilterWithSearch
        accountId={user?.accountId}
          text="Device"
          value={filters?.devicename?.option || ""}
          isSortable={true}
          onApply={handleDeviceNameFilter}
          onReset={handleDeviceNameResetFilter}
        />
      ),
      dataIndex: "device",
      key: "device",
    },
    {
      title: (
        <DropdownFilterWithSearch
        accountId={user?.accountId}
          text="Location"
          value={filters?.locationzone?.option || ""}
          isSortable={true}
          onApply={handleLocationFilter}
          onReset={handleLocationResetFilter}
        />
      ),
      dataIndex: "location",
      key: "locationzone",
    },
    {
      title: (
        <DropdownFilterWithDateRangePicker
        accountId={user?.accountId}
          text="Last updated"
          value={
            filters?.updatedat?.option || {
              lastupdatedfrom: "",
              lastupdatedto: "",
            }
          }
          isSortable={true}
          onApply={handleLastUpdatedFilter}
          onReset={handleLastUpdatedResetFilter}
        />
      ),
      dataIndex: "lastupdated",
      key: "lastupdated",
    },
    {
      title: <AssetDropdown />,
      dataIndex: "action",
      key: "action",
    },
  ];
  return (
    <div className="ats-tab-card ats-map-view">
      <Table
        loading={isLoading}
        dataSource={dataSource}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          total: count,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          prevIcon: ["Previous"],
          nextIcon: ["Next"],
          onChange: (changedPage, changedPageSize) => {
            dispatch(
              updatePageNo({
                currentPage: pageSize !== changedPageSize ? 1 : changedPage,
                pageSize: changedPageSize,
              })
            );
          },
          showSizeChanger: true,
          locale: {
            items_per_page: "",
          },
        }}
      />
    </div>
  );
}

export default AssetList;
